export const COMPANY_CONFIG = {
    number: "8555980890",
    numberAgent: "18889509714",
    illinoisNumber: "8558541049",
    email: "membersvc@aaalife.com",
} as const;
